import {
  AutocompleteInput,
  ReferenceInput,
  TextInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";
import ProductCodeFilterInput from "../common/ProductCodeFilterInput";
// import InputAdornment from "@mui/material/InputAdornment";
// import SearchIcon from "@mui/icons-material/Search";

const filterToQuery = (searchText) => ({ all: searchText });

const saleFilterList = (permissions) => {
  return [
    // <TextInput
    //   source="all"
    //   label="mine.filter.search_all"
    //   alwaysOn
    //   resettable
    //   variant="outlined"
    //   InputProps={{
    //     endAdornment: (
    //       <InputAdornment position="end">
    //         <SearchIcon />
    //       </InputAdornment>
    //     ),
    //   }}
    // />,
    <TextInput
      alwaysOn
      source="code"
      label="mine.label.receipt_no"
      resettable
      variant="outlined"
    />,
    <TextInput
      alwaysOn
      source="order_no"
      label="mine.label.order_no"
      resettable
      variant="outlined"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      label="mine.label.start_date"
      variant="outlined"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      label="mine.label.end_date"
      variant="outlined"
      minDateSource="start_date"
    />,
    <ReferenceInput source="customer" reference="customers" alwaysOn resettable>
      <AutocompleteInput
        label="mine.label.customer"
        optionText="name"
        variant="outlined"
        filterToQuery={filterToQuery}
      />
    </ReferenceInput>,
    <ReferenceInput source="salesman" reference="salesmen" alwaysOn resettable>
      <AutocompleteInput
        optionText="name"
        variant="outlined"
        filterToQuery={filterToQuery}
      />
    </ReferenceInput>,
    <ReferenceInput source="transport_id" reference="transports" alwaysOn>
      <AutocompleteInput
        optionText="name"
        // resettable // FIXME: Autocomplete didalam referencefield tidak perlu resettable
        variant="outlined"
        // label="mine.label.transport"
      />
    </ReferenceInput>,
    <ProductCodeFilterInput
      alwaysOn
      source="goods_code"
      variant="outlined"
      label="mine.label.goods_code"
    />,
    <ReferenceInput alwaysOn source="quality_id" reference="qualities">
      <AutocompleteInput
        label="mine.label.quality"
        variant="outlined"
        fullWidth
        optionValue="id"
        optionText="name"
        filterToQuery={(searchText) => ({
          name: searchText,
        })}
      />
    </ReferenceInput>,
    <ReferenceInput alwaysOn source="size_id" reference="sizes">
      <AutocompleteInput
        label="mine.label.size"
        variant="outlined"
        fullWidth
        optionValue="id"
        optionText="name"
        filterToQuery={(searchText) => ({
          name: searchText,
        })}
      />
    </ReferenceInput>,
    <TextInput
      alwaysOn
      source="note"
      label="mine.label.note"
      resettable
      variant="outlined"
    />,
  ];
};
export default saleFilterList;
